import GeneratedToAddressStore from "./generated/GeneratedToAddressStore"

class ToAddressStore extends GeneratedToAddressStore {

}

export const toAddressStore = new ToAddressStore()
